import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IDeliveryMethod } from "../types/seederOrders";

const API = process.env.REACT_APP_API;

interface IUpdateDeliveryMethodPayload {
  id: number;
  title: string;
  description: string;
  fee: string;
  is_home_delivery: boolean;
}

const useUpdateDeliveryMethod = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: IUpdateDeliveryMethodPayload) => {
      const { id, ...data } = payload;
      return fetch(`${API}/api/semeadora/delivery-methods-manage/${id}/`, {
        method: "PATCH",
        body: data,
      }) as Promise<IDeliveryMethod>;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["delivery-methods"]);
      },
    },
  );
};

export default useUpdateDeliveryMethod;
